import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import {BaseIcon} from './BaseIcon';
import {CurrentIcon} from './CurrentIcon';
import DoneIcon from '@material-ui/icons/Done';

const useColorLibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 30,
        height: 30,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    active: {
        backgroundColor: '#367c2b',
        color: '#367c2b',
    },
    completed: {
        backgroundColor: '#454545'
    },
    disabled: {
        backgroundColor: '#ccc'
    },
});

export function ColorLibStepIcon(props) {
    const classes = useColorLibStepIconStyles();
    const { active, completed, disabled } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
                [classes.disabled]: disabled,
            })}
        >
            {active ? (<CurrentIcon/>) : completed ? <DoneIcon/> : disabled ? <DoneIcon/> : (<BaseIcon/>)}
        </div>
    );
}

ColorLibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    isCurrentStep: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
    disabled: PropTypes.bool,
    /**
     * The current node.
     */
    icon: PropTypes.node
};


